import type { I18nService } from '@shared/types/i18n';
import type { Maybe, Nullable } from '@shared/types/utils';
import type { PriceType } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/common.pb';

import {
  PRICE_TYPE_TOTAL as UBFF_PRICE_TYPE_TOTAL,
  PRICE_TYPE_PER_NIGHT as UBFF_PRICE_TYPE_PER_NIGHT,
} from '@shared/constants/ubff-gateway';

const PRICE_TYPE_TOTAL = 'total';
const PRICE_TYPE_PER_NIGHT = 'price-per-night';

const isPerNightPriceType = (type?: Maybe<string>) =>
  type === PRICE_TYPE_PER_NIGHT;

const getPriceTypeText = (i18n: I18nService, priceType?: string) => {
  if (priceType === PRICE_TYPE_TOTAL || priceType === UBFF_PRICE_TYPE_TOTAL) {
    return i18n.translate('dayView_hotel_card_total');
  }

  return i18n.translate('dayView_hotel_card_a_night');
};

const adaptPriceType = (priceType?: Nullable<string>): PriceType => {
  if (
    priceType === PRICE_TYPE_TOTAL ||
    priceType?.toUpperCase() === UBFF_PRICE_TYPE_TOTAL
  ) {
    return UBFF_PRICE_TYPE_TOTAL;
  }
  return UBFF_PRICE_TYPE_PER_NIGHT;
};

export {
  PRICE_TYPE_TOTAL,
  PRICE_TYPE_PER_NIGHT,
  isPerNightPriceType,
  getPriceTypeText,
  adaptPriceType,
};
